import { createReducer, Action, on } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';

import { INotification } from '@common/modules/core/services/toast/interfaces';

import * as NotificationsActions from '../../actions/notifications.actions';

export interface AlertsState extends EntityState<INotification> {
  // additional entities state properties
}

function selectAccountId(a: INotification): string {
  return a.id;
}

export const adapter: EntityAdapter<INotification> = createEntityAdapter<INotification>({
  selectId: selectAccountId
});

export const initialAlertsState: AlertsState = adapter.getInitialState({
  // additional entity state properties
});

const notificationsAlertsReducer = createReducer(
  initialAlertsState,
  on(NotificationsActions.addNotificationsAlerts, (state, { notifications }) => {
    return adapter.upsertMany(notifications, state);
  }),
  on(NotificationsActions.updateNotificationsAlerts, (state, { notifications }) => {
    return adapter.updateMany(notifications, state);
  }),
  on(NotificationsActions.removeNotificationsAlerts, (state, { ids }) => {
    return adapter.removeMany(ids, state);
  }),
  on(NotificationsActions.clearNotificationsAlerts, state => {
    return adapter.removeAll(state);
  }),
  on(NotificationsActions.removeNotifications, (state, { ids }) => {
    return adapter.removeMany(ids, state);
  })
);

export function reducer(state: AlertsState | undefined, action: Action) {
  return notificationsAlertsReducer(state, action);
}
